import React, { useEffect } from "react";
import PropTypes from "prop-types";

const GoogleSearchAds = ({ searchQuery, isMobile }) => {
  useEffect(() => {
    const scriptId = "google-csa-core-engine";
    let adScript = document.getElementById(scriptId);
    if (!adScript) {
      adScript = document.createElement("script");
      adScript.id = scriptId;
      adScript.src = "https://www.google.com/adsense/search/ads.js";
      adScript.async = true;
      document.head.appendChild(adScript);

      const queueScript = document.createElement("script");
      queueScript.type = "text/javascript";
      queueScript.charset = "utf-8";
      queueScript.appendChild(
        document.createTextNode(`
        (function(g,o){g[o]=g[o]||function(){(g[o]['q']=g[o]['q']||[]).push(
          arguments)},g[o]['t']=1*new Date})(window,'_googCsa');
      `)
      );
      document.head.appendChild(queueScript);
    }

    const dispatchAds = () => {
      if (typeof window._googCsa !== "function") return;

      const pageOptions = {
        pubId: "partner-pub-1061537832961820",
        query: searchQuery || "gulf news",
        styleId: "9032535527",
        adsafe: "high",
        adLoadedCallback: function (containerName, adsLoaded) {
          if (!adsLoaded) {
            const targetElement = document.getElementById(containerName);
            if (targetElement) targetElement.style.display = "none";
          }
        },
      };

      const topBlockOptions = {
        container: "csa-top-leaderboard",
        number: isMobile === "mobile" ? 1 : 2,
        lines: 3,
      };

      const sidebarBlockOptions = {
        container: "csa-sidebar-premium",
        number: isMobile === "mobile" ? 0 : 1,
      };
      window._googCsa("ads", pageOptions, topBlockOptions, sidebarBlockOptions);
    };
    if (window._googCsa) {
      dispatchAds();
    } else {
      adScript.addEventListener("load", dispatchAds);
    }
    return () => {
      if (adScript) adScript.removeEventListener("load", dispatchAds);
      const topDiv = document.getElementById("csa-top-leaderboard");
      const sideDiv = document.getElementById("csa-sidebar-premium");
      if (topDiv) topDiv.innerHTML = "";
      if (sideDiv) sideDiv.innerHTML = "";
    };
  }, [searchQuery, isMobile]);

  return null;
};

GoogleSearchAds.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  isMobile: PropTypes.string,
};

export default GoogleSearchAds;
